import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import SignatureCanvas from "react-signature-canvas";
import cn from "classnames";

import { Uploader } from "services/action";

const SignatureSection = ({ onClose, setSig, loading }) => {
  const Dispatch = useDispatch();
  const sigCanvas = React.useRef(null);

  const clear = () => sigCanvas.current.clear();
  const save = () => {
    $handleSave(sigCanvas?.current?.getTrimmedCanvas()?.toDataURL("image/png"));
  };

  const $handleSave = async (a) => {
    let payload = {
      file: a,
    };
    const req = await Dispatch(Uploader.$upload(payload));

    if (req?.message === "success") {
      const data = {
        image: req?.data,
        type: "signature",
      };

      setSig(data);
      onClose();
    }
  };

  return (
    <div className="padContainer">
      <div className="page-head container">
        <div className="modal-header border-bottom-0 p-2 ps-3 text-center align-items-center justify-content-center position-relative">
          <div className="modal-title text-capitalize" style={{ fontSize: 14 }}>
            E-Signature
          </div>
          <Button
            type="button"
            variant="light"
            className="btn-close me-1"
            aria-label="Close"
            onClick={onClose}
          />
        </div>
      </div>
      <div className="px-3 bg-light h-100">
        <div className="py-2">
          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{ className: "sigPad rounded" }}
          />
        </div>

        <div className="row">
          <div className="col-6">
            <Button
              type="button"
              variant="success"
              className={cn("w-100 fs-7", loading ? "btn-loading" : "")}
              onClick={save}
              disabled={loading}
            >
              Simpan
            </Button>
          </div>
          <div className="col-6">
            <Button
              type="button"
              variant="warning"
              className="w-100 fs-7"
              onClick={clear}
              disabled={loading}
            >
              Hapus
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureSection;
